<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YUkbyt/tc-custom/9781623808839.jpg?1718106505938" alt="This image is the cover for the book Sobre luces y sombras, Caballo Oscuro"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sobre luces y sombras, Caballo Oscuro
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>La secuela de Fuera de la oscuridad<br/>Volumen 3 de la serie Caballo Oscuro</i></b></p><p>Jeff, Evan y Dan han estado juntos los dos últimos años, felices. Todavía tienen problemas, especialmente entre Evan y Dan, pero la mayoría de las veces logran convertir esos desacuerdos interpersonales en tensión sexual, que luego resuelven, así que nadie se queja.</p> <p>Dan llevaba muchos años sin ver a su hermana y cuando esta aparece, embarazada de siete meses y prófuga de la justicia, y la situación se transforma de complicada a abrumadora. Jeff y Evan quieren ayudar, pero como Evan teme por la seguridad de su propia hermana y Jeff debe luchar para mantener bajo control sus problemas de salud, están un poco distraídos.</p> <p>Mientras la hermana de Dan lucha con su pasado, Evan parece querer apostar por su futuro. Con las emociones y los lazos familiares empujándolos en diferentes direcciones, los tres deberán mantenerse juntos, o la gente que aman puede lograr separarlos.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Sherwood, Georgette Asi
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fec54976